





































































































































































































































































































/* tslint:disable */
import { SwExtendedVue } from '@libs-uuif/shared/sw-extended-vue';
import { Component, Prop } from 'vue-property-decorator';
import SwEmailInput from './sw-email-input.vue';
import SwPwInput from './sw-pw-input.vue';
import { LoginModel } from '../interfaces/sw-login-interfaces';
import SwTfaDialog from './sw-tfa-dialog.vue';
import { messageService } from '@sonicwall/unified-ui-framework/src/shared/message-service';
import { envCongif } from '@/shared/env.config';
import * as decode from 'jwt-decode';
import { currentUserKey } from '../../../../shared/msw-constants';
import idb, { CSC_STORE_NAME } from '@/services/indexedDb.service';
import SwCaptchaDialog from './sw-captcha-dialog.vue';
import _, { constant } from 'lodash';
import { Mutation } from 'vuex-class';
import { VuexMappedMutation } from '@sonicwall/unified-ui-framework/src/shared/common-types';
import { SetTFAModePayload } from '../../../core.store';
import { SwStatusInfo } from '@sonicwall/unified-ui-framework/src/shared/sw-status-info';
import { confirmService } from '@libs-uuif/shared/confirm-service';
@Component({
  components: {
    SwEmailInput,
    SwPwInput,
    SwTfaDialog,
    SwCaptchaDialog,
    SwStatusInfo,
  },
})
export default class SwLoginLeftLoginPanel extends SwExtendedVue {
  @Prop({ required: true })
  value: LoginModel;
  @Prop({ default: false })
  flatEdge: boolean;
  
  @Mutation
  setTfaMode: VuexMappedMutation<SetTFAModePayload>;

  emailValid: boolean = true;
  pwReady: boolean = false;
  passwordValid: boolean = true;
  isDomainUser: boolean;
  deviceCode: string = '';
  tfaMedium: string = '';
  email: string = '';
  username : string = '';
  isDemo : boolean = false;
  tileName : string = '';
  environment: string = envCongif.env !== 'PROD' ? envCongif.env : '';
  isusernameerr: boolean;
  next: boolean = false;
  isIDPenabled: string;
  buildVersion: string = '';
  clientID: string = 'GMSB5C64F1SPOG';
  showRememberMe: boolean = false;
  userCaptchaData: any = {};
  captchaText: string = '';
  showPasswordCaptcha: boolean = false;
  captchaResponse: string = '';
  isCaptchaNeeded: boolean = false;
  showTFADialog: boolean = false;
  isShowMaintenance: boolean = false;
  maintenanceMessage: string = '';
  statusLink: string = '';

  closeMaintenanceBanner() {
    this.isShowMaintenance = false;
  }
  created() {
    this.clearCurrentUserToken();
    localStorage.removeItem('currentVersion');
    this.deviceCode = this.getDeviceCode('dcode');
    this.checkIfIE();
    if (this.$route.query.logout) {
      const request = {
        clearCart: 'YES',
      };
      this.$store.dispatch('logout', request)
      .then((result: any) => {
        this.refreshLocalForage();
        if (JSON.parse((localStorage as any).getItem('showPendo'))) {
          localStorage.removeItem('showPendo');
        }
        this.$store.commit('stopLoading');
        console.warn(result);
      });
    } else {
      this.refreshLocalForage();
    }
    if (this.$route.query.code) {
      this.fromMsw();
    }
    if (this.$route.query.token) {
      const decodedToken : any = decode(this.$route.query.token.toString());
      let bispoguser: boolean = false;
      if (decodedToken.clientId === 'GMSB5C64F1SPOG' || decodedToken.clientId === 'B9C8GF1SPOGPRO') {
        bispoguser = true;
      }
      const res: any = {
        msgCode: '',
        msgDesc: '',
        content: {
          deviceCode: '',
          defaultApplication: 'MSW',
          sId: decodedToken.sId,
          isFreeTrial: '',
          userName: decodedToken.userName,
          emailAddress: decodedToken.email,
          givenName: decodedToken.givenName,
          token: this.$route.query.token,
          TFA: 'OFF',
          roles: decodedToken.roles,
          showRegisterPopup: decodedToken.showRegisterPopup,
          showRememberMe: 'true',
          spogUser: bispoguser,
        },
      };
      if (decodedToken.showPendo && decodedToken.showPendo !== '') {
        localStorage.setItem('showPendo', decodedToken.showPendo)
      }
      this.$store.dispatch('preserveUserInfo', res);
      if (this.$route.query.mode && (this.$route.query.tenant || this.$route.query.serialnumber) && this.$route.query.stile) {
        if (this.$route.query.tenant) {
          // tslint:disable-next-line:max-line-length
          this.$router.push({ path: `/m/feature/spog-homepage?mode=${this.$route.query.mode}&stile=${this.$route.query.stile}&tenant=${this.$route.query.tenant}` });
        } else {
          // tslint:disable-next-line:max-line-length
          this.$router.push({ path: `/m/feature/spog-homepage?mode=${this.$route.query.mode}&stile=${this.$route.query.stile}&serialnumber=${this.$route.query.serialnumber}` });
        }
      } else {
        const embedStr = this.$route.query.embed === 'YES' ? '?embed=YES' : '';
        const tenantStr = this.$route.query.tenant && embedStr  ? `&tenantid=${this.$route.query.tenant}` : '';
        this.$router.push({ path: `/m/feature/spog-homepage${embedStr}${tenantStr}` });
      }
    }
    if (this.$route.query.showdemo) {
      this.resetVueStore();
      localStorage.setItem(currentUserKey, '');
      // const request = {
      //   clearCart: 'YES',
      // };
      // this.$store.dispatch('logout', request)
      // .then((result: any) => {
      //   this.$store.commit('stopLoading');
      //   console.warn(result);
      // });
      // this.loginService.logout(true, "YES");
      // this.userInfoService.removeUserInfo();
      // this.userInfoService.setFirstLastName(" ");
      this.username = 'demo@srademo.com';
      this.isDemo = true;
      if (this.$route.query.tile) {
        this.tileName = this.$route.query.tile.toString();
      }
      // this.password="password";
      this.onNext(true);
    }
    // versio call
    if (this.getVersionInfo() === '') {
      this.$store.dispatch('getAppVersion')
      .then((result: any) => {
        if (result.operationStatus === 'OK') {
          console.warn(result);
          this.buildVersion = result.content.appVersion;
          this.isShowMaintenance = (result.content.isShowMaintenance === 'YES') ? true : false;
          this.maintenanceMessage = result.content.maintenanceMessage ? result.content.maintenanceMessage.split(': ')[0] : '';
          this.statusLink = result.content.maintenanceMessage ? result.content.maintenanceMessage.split(': ')[1] : '';
          if (process.env.version && process.env.version.length > 0) {
            this.buildVersion = `${this.buildVersion}.${process.env.version}`;
          }
          console.warn(this.buildVersion);
          localStorage.setItem('currentVersion', this.buildVersion);
          localStorage.setItem('idpenabled', result.content.enableIDP);
        }
      });
    }
  }

  clearCurrentUserToken(): void {
    const isTitleClick : boolean = (this.$route.query.mode && this.$route.query.mode.toString() === 'tileclick') || false;
    const isEmbbeded: boolean = (this.$route.query.embed && this.$route.query.embed.toString() === 'YES') || false;
    const clearToken: boolean = (isTitleClick || isEmbbeded) || false;
    if (!clearToken) {
      try {
        localStorage.removeItem(currentUserKey);
      } catch (e) {
        console.log(e);
      }
    }
  }

  getDeviceCode(cname: any) {
    const name = `${cname}=`;
    const decodedCookie = decodeURIComponent(document.cookie);
    const ca = decodedCookie.split(';');
    for (let i = 0; i < ca.length; i = i + 1) {
      let c = ca[i];
      while (c.charAt(0) === ' ') {
        c = c.substring(1);
      }
      if (c.indexOf(name) === 0) {
        return c.substring(name.length, c.length);
      }
    }
    return '';
  }

  fromMsw() {
    this.$store.dispatch('exchangeCodeForToken', { accessCode: this.$route.query.code })
    .then((resp: any) => {
      const decodedToken: any = decode(resp.content.token.toString());
      let bispoguser: boolean = false;
      if (decodedToken.clientId === 'GMSB5C64F1SPOG' || decodedToken.clientId === 'B9C8GF1SPOGPRO') {
        bispoguser = true;
      }
      const res: any = {
        msgCode: '',
        msgDesc: '',
        content: {
          deviceCode: '',
          defaultApplication: 'MSW',
          sId: decodedToken.sId,
          isFreeTrial: '',
          userName: decodedToken.userName,
          emailAddress: decodedToken.email,
          givenName: decodedToken.givenName,
          token: resp.content.token,
          TFA: 'OFF',
          roles: decodedToken.roles,
          showRegisterPopup: decodedToken.showRegisterPopup,
          showRememberMe: 'true',
          spogUser: bispoguser,
        },
      };
      let queryParams = {};
      if (this.$route.query.mode || this.$route.query.tile || this.$route.query.tenantid || this.$route.query.stile) {
        queryParams = {
          ...(this.$route.query.mode && { mode: this.$route.query.mode.toString() }),
          ...(this.$route.query.tile && { tile: this.$route.query.tile.toString() }),
          ...(this.$route.query.stile && { stile: this.$route.query.stile.toString() }),
          ...(this.$route.query.tenantid && { tenantid: this.$route.query.tenantid.toString() }),
        };
      }
      if (decodedToken.showPendo && decodedToken.showPendo !== '') {
        localStorage.setItem('showPendo', decodedToken.showPendo)
      }
      this.$store.dispatch('preserveUserInfo', res);
      this.$router.push({ path: '/m/feature/spog-homepage',  query: { ...queryParams }});
    });
  }

  checkIfIE() {
    const ua = window.navigator.userAgent;
    const isIE = /MSIE|Trident/.test(ua);
    if (isIE) {
      const errorMessage = 'Capture Security Center currently supports the latest versions of Chrome, Edge, Firefox and Safari.';
      messageService.messageManager.showMessage('login-message', errorMessage , 'failed');
    }
  }

  getVersionInfo() {
    const versionInfoString = localStorage.getItem('currentVersion');
    if (versionInfoString) {
      const versionObj = localStorage.getItem('currentVersion');
      return versionObj;
    }
    return '';
  }
  checkEmail() {
    if (this.value.email.length > 0) {
      // this.isIDPenabled = this.getIDPValue()!.toString();
      let idptoken = '';
      let idpUrlFromSpog = '';
      this.$store.commit('startLoading');
      this.$store.dispatch('getAppVersion')
        .then((resp: any) => {
          if (resp.operationStatus === 'OK' && resp.content.enableIDP) {
            // this.spinner = true;
            const payload = {
              emailAddress: this.value.email,
              source: this.determineSource(),
            };
            this.$store.dispatch('getIDPUrl', payload)
              .then((result: any) => {
                let spinnerFlag = true;
                if (result?.content?.isSPRedirect && result?.content?.isSPRedirect === 'YES') {
                  confirmService.confirm({
                    status: 'major',
                    message: String(this.$t('sp.spRedirectMsg2')),
                    buttons: [
                      {
                        key: 'cancel',
                        name: String(this.$t('accessMgmt.cancel')),
                      },
                      {
                        key: 'ok',
                        name: String(this.$t('accessMgmt.confirm')),
                        isDefault: true,
                      },
                    ],
                  })
                  .then((isConfirmed: any) => {
                    if (isConfirmed === 'ok') {
                      window.top.location.href = `${envCongif.sp_url}`;
                    }
                  });
                }
                if (result.content.hasOwnProperty('extAuth') && result.content['extAuth'] === 'YES') {
                  spinnerFlag = false;
                }
                if (result && result.content && result.content.IDPUrl && result.content.IDPUrl !== '') {
                  window.top.location.href = result.content.IDPUrl;
                  return;
                }
                if (spinnerFlag) {
                  this.$store.commit('stopLoading');
                }
              });
          }
        });
      if (
        this.value.email.split('@').length === 2 &&
        this.$store.getters.isFederatedEmail(this.value.email.split('@')[1])
      ) {
        this.$store.dispatch('isFederatedUser', this.value.email)
        .then(() => {
          this.$store.commit('stopLoading');
        });
        this.pwReady = true;
      } else {
        this.pwReady = true;
      }
    } else {
      this.emailValid = false;
    }
  }

  determineSource() {
    return 'CLOUD';
  }

  onNext(bisforced: boolean = false) {
    this.isusernameerr = false;
    let idptoken = '';
    let idpUrlFromSpog = '';
    this.next = false;
    if (this.username !== '') {
      const userEmail = this.username.split('@');
      this.isIDPenabled = this.getIDPValue()!.toString();
      if (this.isIDPenabled === 'true') {
        this.$store.commit('startLoading');
        const payload = {
          emailAddress: this.value.email,
          source: this.determineSource(),
        };
        this.$store.dispatch('getIDPUrl', payload)
        .then((res: any) => {
          let str = '';
          let url = '';
          console.warn(res?.content);
          if (res?.content?.isSPRedirect && res?.content?.isSPRedirect === 'YES') {
            console.warn(res?.content?.isSPRedirect);
            confirmService.confirm({
              status: 'major',
              message: String(this.$t('sp.spRedirectMsg2')),
              buttons: [
                {
                  key: 'cancel',
                  name: String(this.$t('accessMgmt.cancel')),
                },
                {
                  key: 'ok',
                  name: String(this.$t('accessMgmt.confirm')),
                  isDefault: true,
                },
              ],
            })
            .then((isConfirmed : any) => {
              if (isConfirmed === 'ok') {
                window.top.location.href = `${envCongif.sp_url}`;
              }
            });
          }
          if (res && res.content && res.content.IDPUrl) {
            str = res.content.IDPUrl;
            idpUrlFromSpog = str.split('?')[0];
            idptoken = str.split('?')[1];
            url = `${envCongif.msw_url}/muir/login?`;
          }
          
          if (str !== '') {
          // window.top.location.href = str
            window.top.location.href = `${url}idpUrlFromSpog=${idpUrlFromSpog}&idptoken=${idptoken}`;
            return;
          }
          this.$store.commit('stopLoading');
        });
      }
      if ((userEmail.length === 2) && this.$store.getters.isFederatedEmail(userEmail[1])) {
        this.$store.commit('startLoading');
        this.$store.dispatch('isFederatedUser', this.username)
          .then((resp) => {
            if (resp.success) {
              this.isDomainUser = true;
            }
            this.$store.commit('stopLoading');
          });
      }
      this.next = true;
      if (bisforced) {
        this.validateLogin(true);
          // this.login(bisforced);
        return;
      }
      // setTimeout(() => {
      //   document.getElementById('password')
      //   .focus();
      //   document.getElementById('password')
      //       .addEventListener('keyup', function (event) {
      //         event.preventDefault();
      //       if (event.keyCode === 13) {
      //         document.getElementById('loginButton').click();
      //       }
      //     });
      // }, 0);
    } else {
      this.isusernameerr = true;
    }
  }
  inIframe(): boolean {
    try {
      return window.self !== window.top;
    } catch (e) {
      return true;
    }
  }
  getIDPValue() {
    try {
      const idpValueString = localStorage.getItem('idpenabled');
      if (idpValueString) {
        const idpObj = localStorage.getItem('idpenabled');
        return idpObj;
      }
      return 'false';
    } catch (e) {
      return 'false';
    }
  }
  resetVueStore() {
    this.$store.commit('startLoading');
    this.$store.dispatch('resetStore');
    this.$store.dispatch('DashBoardStoreModule/resetStore');
    this.$store.dispatch('MswProductsStoreModule/resetStore');
    this.$store.dispatch('DropdownStoreModule/resetStore');
  }
  validateLogin(isforced: boolean = false) {
    if (this.value.password.length > 0 || isforced) {
      if (isforced) {
        this.value.email = this.username;
        this.value.password = 'password';
      }
      this.$store.commit('mutate', { property: 'clientId', with: 'GMSB5C64F1SPOG' });
      // this.$store.commit('mutate', { property: 'clientId', with: 'MUIR1XHIS27' });
      const obj = {
        userName: this.value.email,
        password: this.value.password,
        clientId: this.$store.getters.getClientId,
        deviceCode: this.deviceCode,
        captchaText: this.captchaText ? this.captchaText : '',
      };
      this.$store.commit('startLoading');
      this.$store.dispatch('getTokenForSpog', obj)
        .then((res: any) => {
          this.showPasswordCaptcha = false;
          this.captchaText = '';
          if (res.operationStatus === 'OK') {
            if (res.content.showRememberMe && !res.content.deviceCode) {
              this.showRememberMe = true;
            }
            if (res.content.isTFACaptchaNeeded && res.content.isTFACaptchaNeeded === "YES") {
              this.isCaptchaNeeded = true;
            }
            if (res.content.deviceCode && res.content.deviceCode !== '') {
              this.setCookie('dcode', res.content.deviceCode);
            }
            if (res.content.isLargeCustomer === 'YES') {
              localStorage.setItem('isLargeCustomer', 'YES');
            } else {
              localStorage.setItem('isLargeCustomer', 'NO');
            }
            if (res.content && res.content.TFAID) {
              localStorage.setItem('TFAID', res.content.TFAID.toString());
            }
            if (res.content && res.content.token && res.content.token !== '') {
              const decodedToken: any = decode(res.content.token);
              if (decodedToken.showPendo && decodedToken.showPendo !== '') {
                localStorage.setItem('showPendo', decodedToken.showPendo)
              }
            }
            this.$store.commit('stopLoading');
            this.$store.dispatch('preserveUserInfo', res);
            if (res.msgCode === 'MSWAPP:TFA') {
              this.tfaMedium = res.content.TFA.toUpperCase();
              this.setTfaMode({ mode: this.tfaMedium });
              this.email = res.content.emailAddress;
              this.showTFADialog = true;
            } else {
              this.$store.commit('mutate', { property: 'loggedIn', with: true });
              if (this.$router.currentRoute.query!.redirectURL) {
                this.$router.push({ path: atob(this.$router.currentRoute.query.redirectURL as string) });
              } else {
                this.$router.push('/m/feature/spog-homepage');
              }
            }
          } else if (res.messageCode === 'MSWAPP:ACCOUNTLOCKED') {
            this.$store.commit('stopLoading');
            const errorMessage = 'Your account has been locked. Please visit  MySonicwall.com to reset the password';
            messageService.messageManager.showMessage('login-message', errorMessage , 'failed');
          } else if (res.messageCode === 'MSWAPP:TEMPCUSTOMER') {
            this.$store.commit('stopLoading');
            const errorMessage = 'Please visit  MySonicwall.com to complete the signup Process';
            messageService.messageManager.showMessage('login-message', errorMessage , 'failed');
          } else if((res.msgCode === 'SHOWCAPTCHA' ||
            res.msgCode === 'INVALIDCAPTCHA') &&
            res.content.hasOwnProperty('captchBaseString') && 
            res.content.captchBaseString && 
            res.content.hasOwnProperty('captchDetail') &&
            res.content.captchDetail) {
            this.userCaptchaData = {};
            this.userCaptchaData.captchDetail = res.content.captchDetail ? res.content.captchDetail : '';
            this.userCaptchaData.captchBaseString = res.content.captchBaseString ? res.content.captchBaseString : '';
            this.$store.commit('stopLoading');
            if (res.msgCode === 'INVALIDCAPTCHA') {
              messageService.messageManager.showMessage('login-message', res.msgDesc ? res.msgDesc : '' , 'failed');
            }
            this.showPasswordCaptcha = true;
          } else if (res.messageCode === 'MSWAPP:REQUESTREGISTRATIONCODE') {
            this.$store.commit('stopLoading');
            const errorMessage = 'Please visit  MySonicwall.com to complete the login.';
            messageService.messageManager.showMessage('login-message', errorMessage , 'failed');
          } else {
            this.$store.commit('stopLoading');
            const errorMessage = res['msgDesc'] || 'The Username/Email address or Password entered, is not correct. Please check and try again.';
            messageService.messageManager.showMessage('login-message', errorMessage , 'failed');
          }
        });
    } else {
      this.passwordValid = false;
    }
  }

  closeTFADialog() {
    this.showTFADialog = false;
    this.tfaMedium = '';
  }

  setCookie(cookieKey: any, cookieValue: any) {
    this.removeCookie(cookieKey)
    .then(() => {
      document.cookie = `${cookieKey}=${cookieValue}`;
    });
  }

  removeCookie(cookieKey: any) {
    return new Promise((resolve: any, reject: any) => {
      console.warn(reject);
      document.cookie = `${cookieKey}=`;
      resolve(true);
    });
  }

  redirectingToMSWPages(urlExt : string) {
    if (urlExt === 'signup') {
      const signupURL: URL = new URL(`${envCongif.sp_url}/m/apps/msw/m/signup`);
      window.location.href = signupURL.toString();
    } else if (urlExt === 'forgotpassword') {
      this.$router.push({ path: '/g/forgot-password', query: this.value.email ? { email: this.value.email } : {} });
    } else {
      this.$router.push({ path: '/g/forgotusername' });
    }
  }
  openSupportedbrowser() {
    this.$emit('openSlider', true);
  }
  refreshLocalForage() {
    localStorage.setItem(currentUserKey, '');
    this.resetVueStore();
    idb.refreshStore(CSC_STORE_NAME);
    idb.removeItem(CSC_STORE_NAME);
  }
  onCloseEvent(value: string = '') {
    if (value) {
      this.captchaText = value;
      this.validateLogin();
    }
    this.showPasswordCaptcha = false;
  }
}
